module.exports = __webpack_public_path__ + "static/media/stats-filled.1fc3ac8b.png";